// Shared audit reason for the explicit supplier-outreach skip business action.
// This is supplier workflow only and is unrelated to the customer's channel.
export const SKIP_SUPPLIERS_REASON = "Recent quote on file found, skipping sending to suppliers";
